import { useEffect, useRef, useState } from "react";
import { SECTIONS, THEMES, scrollTo } from "../data/constants";
import { IconFile, IconSpark } from "./icons";

/* A native <select>: keyboard navigation, Escape to dismiss, outside-click,
   and the OS picker on mobile all come for free. A hand-rolled listbox would
   be ~80 lines to reach the same behaviour, and worse on a phone. */
function ThemePicker() {
  const [theme, setTheme] = useState(
    () => document.documentElement.dataset.theme || "dark"
  );

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    try {
      localStorage.setItem("theme", theme);
    } catch {
      /* private mode / storage disabled — the theme still applies for this visit */
    }
  }, [theme]);

  return (
    <div className="theme-picker">
      <IconSpark width={13} height={13} />
      <label className="picker-label" htmlFor="theme-select">Theme</label>
      <select
        id="theme-select"
        value={theme}
        onChange={(e) => setTheme(e.target.value)}
      >
        {THEMES.map(({ id, label }) => (
          <option key={id} value={id}>{label}</option>
        ))}
      </select>
    </div>
  );
}

export default function TabBar({ active }) {
  const barRef = useRef(null);

  // Keep the active tab visible when the bar overflows — same as an editor does.
  // scrollIntoView is avoided on purpose: it walks up and scrolls ancestors too,
  // which fights the page's own smooth scroll. Scroll only this element.
  useEffect(() => {
    const bar = barRef.current;
    if (!bar || bar.scrollWidth <= bar.clientWidth) return;   // nothing to scroll

    const tab = bar.querySelector(".tab.active");
    if (!tab) return;
    bar.scrollTo({ left: tab.offsetLeft - (bar.clientWidth - tab.clientWidth) / 2, behavior: "smooth" });
  }, [active]);

  return (
    <div className="tabstrip">
      <div className="tabbar" ref={barRef} role="tablist" aria-label="Sections">
        {SECTIONS.map(({ id, label }) => (
          <button
            key={id}
            role="tab"
            aria-selected={active === id}
            className={`tab${active === id ? " active" : ""}`}
            onClick={() => scrollTo(id)}
          >
            <span className="dotfile"><IconFile width={13} height={13} /></span>
            {label}
          </button>
        ))}
      </div>

      <ThemePicker />
    </div>
  );
}
